module.exports = __webpack_public_path__ + "static/media/model.fb56a719.glb";